// Active dungeon layout — module singleton. B1 keeps generated structure
// behind the cheat (`cheat.dungeon(seed)`); the open-water world stays the
// shipped default until B2 migrates it. Render + collision both read this;
// `version` lets the render pass re-upload the primitive buffer only when
// the layout actually changes.

import type { DungeonLayout } from './types'

let active: DungeonLayout | null = null
let version = 0

export function setActiveDungeon(layout: DungeonLayout | null): void {
  active = layout
  version++
}

export function getActiveDungeon(): DungeonLayout | null {
  return active
}

export function activeDungeonVersion(): number {
  return version
}
